import React from 'react';
import ReactCountryFlag from "react-country-flag";

import {
    countryCodeToNameMap,
} from './memory';

export const ConsoleLog = () => false;

export const PlaceHolderImage = 'https://www.lifo.gr/icache/1200/630/2_3058397870/1623308_paralia-thessalonikis-timelapse.jpg';

export const CountryFlagWithName = ({ code }) => (
    <span style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }}>
        <ReactCountryFlag
            countryCode={code}
            svg
            style={{
                flex: '0 1 auto',
                marginRight: '0.5em',
            }}
            title={countryCodeToNameMap[code]}
        />
        <span style={{
            flex: '0 1 auto',
        }}>
        {countryCodeToNameMap[code]}
        </span>
    </span>
);

export const formatTimeToDate = date => {
    return date.slice(0, date.indexOf('T'));
}

export function capitalizeFirstLetter(string) {
  return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
}

export const queryToString = query => {
    const {
        category = "",
        country = "",
        source = [],
        search = "",
        searchInTitle = "",
        language = "",
        sortBy = "",
    } = query;
    return category + country + search + searchInTitle + language + sortBy +
        (source === null ? '' : source.join(''));
}
